export const THEME = {
  colors: {
    black: "#000000",
    white: "#ffffff",
    primary: "#3498db",
    secondary: "#2ecc71",
    background: "#ffffff",
    needPay: "#ffeaeaff",
    totalPay: "#ddddddff",
    totalGreen: "#f1ffe3ff",
    text: "#2c3e50",
    error: "#e74c3c",
    backgroundAlert: "#fbe1e1ff",
    cardMessageNoItem: "#ffffffff",
    cardPromotionsLinked: "#ffffffff",
    colorEmployeeCard: "rgb(255, 255, 255)",
    iconBGAlertColor: "#ff0000ff",
    iconBGLessColor: "#1c8200ff",
    iconBGColor: "#000000ff",
    iconBGSecondaryColor: "#202020ff",
    buttonBGImgColor: "#474747ff",
    buttonFGImgColor: "#000000ff",
    buttonBGCloseColor: "#ff0000be",
    buttonFGCloseColor: "#000000be",
    buttonBGExpandColor: "#4a4a4aff",
    buttonFGExpandColor: "#ffffffff",
    buttonBGSaveColor: "#fdba74",
    buttonFGSaveColor: "#7c2d12",
    buttonBGPlusColor: "#008268ff",
    buttonBGHelpColor: "#18DB9B",
    buttonFGPlusColor: "#000000ff",
    buttonBGRemoveColor: "#ff0000ff",
    buttonFGRemoveColor: "#000000ff",
    buttonBGLoginColor: "#fc5628ff",
    buttonBGRegisterColor: "#525252",
    buttonFGRegisterColor: "#ffffff",
  },
  fonts: {
    regular: "Inter, sans-serif",
    bold: "Inter Black, sans-serif",
  },
  fontSizes: {
    small: "12px",
    medium: "16px",
    large: "20px",
  },
  spacing: {
    small: "8px",
    medium: "16px",
    large: "24px",
  },
}

export type ThemeType = typeof THEME
export default THEME
